import React from 'react'
import { FormikProps } from 'formik'
import { IntlShape } from 'react-intl'
import { TourDetails } from '../../../core/_models'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'
import { KTSVG } from '../../../../../../../_dashboard/helpers'

interface FAQProps {
  formik: FormikProps<TourDetails>
  showForm: boolean
  setShowForm: (show: boolean) => void
  newFAQ: { title: string; content: string }
  setNewFAQ: (faq: { title: string; content: string }) => void
  handleAddFAQ: () => void
  intl: IntlShape
  error?: string
}

const FAQ: React.FC<FAQProps> = ({
  formik,
  showForm,
  setShowForm,
  newFAQ,
  setNewFAQ,
  handleAddFAQ,
  intl,
  error
}) => {
  return (
    <div className='mb-10'>
      <label className='form-label'>{intl.formatMessage({ id: 'TOUR.FIELDS.FAQ' })}</label>
      {error && <div className='text-danger mb-3'>{error}</div>}
      <div className='table-responsive'>
        <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
          <thead>
            <tr className='fw-bold text-muted'>
              <th className='min-w-150px'>{intl.formatMessage({ id: 'TOUR.FIELDS.FAQ_TITLE' })}</th>
              <th className='min-w-150px'>{intl.formatMessage({ id: 'TOUR.FIELDS.FAQ_CONTENT' })}</th>
              <th className='min-w-100px text-end'>{intl.formatMessage({ id: 'COLUMNS.ACTIONS' })}</th>
            </tr>
          </thead>
          <tbody>
            {formik.values.faqs?.map((item, index) => (
              <tr key={index}>
                <td>{item.title}</td>
                <td>{item.content}</td>
                <td className='text-end'>
                  <OverlayTrigger
                    placement='top'
                    overlay={<Tooltip>{intl.formatMessage({id: 'ACTION.DELETE'})}</Tooltip>}
                  >
                    <button
                      type='button'
                      className='btn btn-icon btn-light-danger btn-sm'
                      onClick={() => {
                        const newFaqs = formik.values.faqs?.filter((_, i) => i !== index)
                        formik.setFieldValue('faqs', newFaqs)
                      }}
                    >
                      <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                    </button>
                  </OverlayTrigger>
                </td>
              </tr>
            ))}
            {showForm && (
              <tr>
                <td>
                  <input
                    type='text'
                    className='form-control'
                    placeholder={intl.formatMessage({ id: 'TOUR.FIELDS.ENTER_TITLE' })}
                    value={newFAQ.title}
                    onChange={(e) => setNewFAQ({...newFAQ, title: e.target.value})}
                  />
                </td>
                <td>
                  <input
                    type='text'
                    className='form-control'
                    placeholder={intl.formatMessage({ id: 'TOUR.FIELDS.ENTER_CONTENT' })}
                    value={newFAQ.content}
                    onChange={(e) => setNewFAQ({...newFAQ, content: e.target.value})}
                  />
                </td>
                <td className='text-end'>
                  <button
                    type='button'
                    className='btn btn-light-primary btn-sm me-2'
                    onClick={handleAddFAQ}
                  >
                    {intl.formatMessage({ id: 'TOUR.ACTIONS.SAVE' })}
                  </button>
                  <button
                    type='button'
                    className='btn btn-light-danger btn-sm'
                    onClick={() => {
                      setShowForm(false)
                      setNewFAQ({ title: '', content: '' })
                    }}
                  >
                    {intl.formatMessage({ id: 'TOUR.ACTIONS.CANCEL' })}
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!showForm && (
        <button
          type='button'
          className='btn btn-light-primary'
          onClick={() => setShowForm(true)}
        >
          {intl.formatMessage({ id: 'TOUR.ACTIONS.ADD_ELEMENT' })}
        </button>
      )}
    </div>
  )
}

export { FAQ } 